import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "loyalty-config",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const loyaltyConfig = require("./LoyaltyConfig").default;
          cb(null, loyaltyConfig);
        },
        "LoyaltyConfig"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/LoyaltyConfig/index.js